import { I18n } from '@calendly/i18n';
import { Badge } from '@calendly/ui/components/badge';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { isOnTrialStageSelector } from 'features/billing';
import { useBooleanState } from 'hooks/useBooleanState';
import { Wizard as CreateCustomWorkflowModal } from '../../../modals/create_your_own';
import { IntroText } from '../../../styles';
import { HeaderLayout, FlexHeadingSection, HeadingSubSection, HeaderImage, ListTitleButton, ListTitleWrapper } from '../../../styles/layout';
import { EmptyStateTitle } from '../../empty_state_title';
import { HeaderImageSource } from '../images';
const headerRowCss = "hhcxqey";
const HeaderRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerRowCss, props.className)} />;
});
export const Header = ({
  owner
}) => {
  const [popupIsOpen, openPopup, closePopup] = useBooleanState(false);
  const isOnTrial = useSelector(isOnTrialStageSelector);
  return <>
      <FlexHeadingSection>
        <HeadingSubSection>
          {!isOnTrial && <HeaderRow>
              <Badge type="success">{I18n.t('publisher.workflows.empty_state.getting_started')}</Badge>
            </HeaderRow>}
          <HeaderRow>
            <EmptyStateTitle />
          </HeaderRow>
          <HeaderRow>
            <IntroText data-testid="workflows-intro-text">
              {I18n.t('publisher.workflows.empty_state.intro')}
            </IntroText>
          </HeaderRow>
        </HeadingSubSection>
        <HeadingSubSection>
          <HeaderImage src={HeaderImageSource} alt="" />
        </HeadingSubSection>
      </FlexHeadingSection>
      <HeaderLayout>
        <ListTitleWrapper>
          <BodyText size="large">
            {I18n.t('publisher.workflows.empty_state.start_with')}
          </BodyText>
        </ListTitleWrapper>
        <ListTitleButton decoration="outline" size="small" onClick={openPopup}>
          {I18n.t('publisher.workflows.workflow_templates.create_your_own')}
        </ListTitleButton>
      </HeaderLayout>
      <CreateCustomWorkflowModal owner={owner} isOpen={popupIsOpen} onClose={closePopup} />
    </>;
};

require("./header.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./header.js");